import React from 'react';
import { useGame } from '../../context/GameContext';
import { technologies, BALANCE } from '../../data';

function StatsModal({ onClose }) {
  const {
    playerResources,
    researchedTechs,
    stats,
    totalBuildings,
    kingdomTier,
    currentClickPower,
    currentResearchSpeed,
    unlockedAdvisors,
    activeAdvisors,
  } = useGame();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="stats-modal" onClick={e => e.stopPropagation()}>
        <div className="stats-header">
          <h2>📊 Statistics</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="stats-content">
          <div className="stats-section">
            <h3>⏱️ Time</h3>
            <div className="stat-row">
              <span>Play Time:</span>
              <span>{Math.floor(stats.playTime / 3600)}h {Math.floor((stats.playTime % 3600) / 60)}m</span>
            </div>
          </div>
          
          <div className="stats-section">
            <h3>🏗️ Buildings</h3>
            <div className="stat-row">
              <span>Total Built:</span>
              <span>{stats.totalBuildings}</span>
            </div>
            <div className="stat-row">
              <span>Currently Owned:</span>
              <span>{totalBuildings}</span>
            </div>
            <div className="stat-row">
              <span>Specializations:</span>
              <span>{stats.specializationsChosen || 0}</span>
            </div>
          </div>
          
          <div className="stats-section">
            <h3>🔬 Research</h3>
            <div className="stat-row">
              <span>Techs Researched:</span>
              <span>{researchedTechs.length}/{Object.keys(technologies).length}</span>
            </div>
            <div className="stat-row">
              <span>Research Speed:</span>
              <span>{Math.round(currentResearchSpeed * 100)}%</span>
            </div>
          </div>
          
          <div className="stats-section">
            <h3>👆 Clicking</h3>
            <div className="stat-row">
              <span>Total Clicks:</span>
              <span>{stats.totalClicks.toLocaleString()}</span>
            </div>
            <div className="stat-row">
              <span>Click Power:</span>
              <span>+{currentClickPower}</span>
            </div>
          </div>
          
          <div className="stats-section">
            <h3>👑 Advisors</h3>
            <div className="stat-row">
              <span>Unlocked:</span>
              <span>{unlockedAdvisors.length}/{BALANCE.advisors.length}</span>
            </div>
            <div className="stat-row">
              <span>Active:</span>
              <span>{activeAdvisors.length}/{BALANCE.maxAdvisors}</span>
            </div>
          </div>
          
          <div className="stats-section">
            <h3>🏰 Kingdom</h3>
            <div className="stat-row">
              <span>Tier:</span>
              <span>{kingdomTier}</span>
            </div>
            <div className="stat-row">
              <span>Population:</span>
              <span>{Math.floor(playerResources.population || 0)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsModal;
